<template>
    <div class="cont-tit">
        <h2 class="page-title">Business Inquiry</h2>
        <p class="page-desc">If you tell Osang Technology about your business concerns, we will provide you with the optimal solution.</p>
    </div>
    <div class="inquiry ">
        <div class="inquiry__box cont">
            <h3 class="sub-title">Customer Information</h3>
            <label class="inquiry__form type2">
                <div class="inquiry__form-box">
                    <div class="inquiry__tit">Name</div>
                    <input class="inquiry__input" ref='inputName' v-model="this.name">
                </div>
                <div class="inquiry__form-box">
                    <div class="inquiry__tit">Company/Affiliation</div>
                    <input class="inquiry__input" ref='inputAffiliation' v-model="this.affiliation">
                </div>
                <div class="inquiry__form-box">
                    <div class="inquiry__tit">Email</div>
                    <input class="inquiry__input" ref='inputEmail' v-model="this.email">
                </div>
                <div class="inquiry__form-box">
                    <div class="inquiry__tit">Mobile</div>
                    <input class="inquiry__input" ref='inputPhoneNo' v-model="this.phoneNo">
                </div>
            </label>
        </div>

        <div class="inquiry__box cont">
            <h3 class="sub-title">Inquiry Details</h3>
            <label class="inquiry__form">
                <textarea class="inquiry__textarea" style="width: 100%;" ref='inputDetails' v-model="this.detail"></textarea>
            </label>
        </div>

        <div class="inquiry__box cont">
            <h3 class="sub-title">Consent to collect and use personal information <span class="c-red">(required)</span></h3>
            <label class="inquiry__form">
                <div class="text-box">
                    <ul class="text-box__list">
                        <li class="text-box__item">1. Collection items: Required: Name, company/affiliated organization, email, mobile phone, inquiry details</li>
                        <li class="text-box__item">2. Purpose of collection: Consultation for use of Osang Technology services</li>
                        <li class="text-box__item">3. Retention period: 6 months from the date of inquiry</li>
                        <li class="text-box__item">※ If you do not agree to the collection and use of personal information to provide consultation services, you will not be able to receive Osang Technology services.</li>
                    </ul>
                </div>
            </label>
            <div class="inquiry__check">
                <input type="checkbox" id="agree" class="inquiry__input-check" v-model="this.privacyYn">
                <label for="agree" class="inquiry__agree">
                    <span class="checkbox"></span>
                    <p><span class="c-red">(Required)</span> I agree to the collection and use of personal information to provide services.</p>
                </label>
            </div>
        </div>

        <div class="btn-wrap">
            <button type="button" class="btn" @click="submit()">Contact us</button>
        </div>

    </div>
</template>
<script>
    import emailjs from 'emailjs-com';
    export default {
        data(){
            return {
                name : '',
                affiliation : '',
                email : '',
                phoneNo : '',
                detail : '',
                privacyYn : ''
            }
        },
        mounted() {
            document.querySelector(".footer__link").classList.add("dn")
        },
        unmounted() {
            document.querySelector(".footer__link").classList.remove("dn")
        },
        methods: {
            submit() {
                if(this.name == ''){
                    alert('Please enter your name')
                    this.$refs.inputName.focus()
                    return
                }
                if(this.affiliation == ''){
                    alert('Please enter your Company/Affiliation')
                    this.$refs.inputAffiliation.focus()
                    return
                }
                if(this.email == ''){
                    alert('Please enter your Email')
                    this.$refs.inputEmail.focus()
                    return
                }
                if(this.phoneNo == ''){
                    alert('Please enter your Mobile')
                    this.$refs.inputPhoneNo.focus()
                    return
                }
                if(this.detail == ''){
                    alert('Please enter your Inquiry Details')
                    this.$refs.inputDetails.focus()
                    return
                }
                if(this.privacyYn == ''){
                    alert('Please accept my personal information')
                    return
                }
                this.sendEmail();
            },
            sendEmail() {
                const payload = {
                    from_name: this.name,
                    name: this.name,
                    affiliation: this.affiliation,
                    email: this.email,
                    phoneNo: this.phoneNo,
                    detail: this.detail,
                    form_time: new Date()
                }
                emailjs.send('service_y4fk9eo', 'template_z49bj4g', payload, 'aIaEPh7p7td0b3PNV')
                    .then((res) => {
                        alert('Transfer successful');
                        //초기화
                        this.name = ''
                        this.affiliation = ''
                        this.email = ''
                        this.phoneNo = ''
                        this.detail = ''
                        this.privacyYn = ''
                    }, (error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>
    .footer__link {
        display: none !important;
    }
</style>